import script from "./iosInstruction.vue?vue&type=script&lang=ts&setup=true"
export * from "./iosInstruction.vue?vue&type=script&lang=ts&setup=true"

import "./iosInstruction.vue?vue&type=style&index=0&id=c6be65ba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6be65ba"]])

export default __exports__